// extracted by mini-css-extract-plugin
module.exports = {"title":"BuilderApplications_title__ctN1C","subtitle":"BuilderApplications_subtitle__g7kSw","image":"BuilderApplications_image__Dc01w"};